import { Stepper_Edge_default } from "./chunk-G6MWY5HZ.js";
import { Stepper_Node_default } from "./chunk-BVQDRIYW.js";
import { Stepper_default } from "./chunk-AZTBBTZI.js";

// src/components/Stepper/index.tsx
var StepperComponent = Stepper_default;
StepperComponent.Node = Stepper_Node_default;
StepperComponent.Node.displayName = "Stepper.Node";
StepperComponent.Edge = Stepper_Edge_default;
StepperComponent.Edge.displayName = "Stepper.Edge";
export { StepperComponent };